import { useEffect, useState } from "react";
import { useHub } from "../../core/Global";
import Icon from "../base/Icon";
import { toastError } from "../base/Toast";





export default function DataTableActiveToggle(data: any) {

    const hub = useHub();
    const [active, activeSet] = useState<boolean>(false);
    const [working, workingSet] = useState<boolean>(false);

    useEffect(() => {

        activeSet(data.isActive ?? false);

    }, [data.id])

    return (
        <div>
            <label className="form-check form-switch form-switch-sm form-check-custom form-check-solid position-relative">
                <input className="form-check-input" type="checkbox" checked={active} disabled={working}
                    onChange={e => {

                        const next = e.target.checked;
                        let active = next ? "1" : "0";

                        workingSet(true);

                        hub.Post(data.route + "activetoggle", {
                            id: data.id,
                            active: active
                        }, res => {
                            if (res.success) {
                                if (data.callback) data.callback();
                                // Prefer the server's reported value when it returns a boolean,
                                // otherwise fall back to what the user just toggled.
                                activeSet(typeof res.data === "boolean" ? res.data : next);
                            }
                            else {
                                // hub.Post does not toast on its own, so without this a refused
                                // toggle just snaps back and reads as a dead switch.
                                toastError(res.message);
                            }
                            workingSet(false);
                        })


                    }} />
                {
                    working &&
                    <span style={{
                        position: "absolute",
                        right: active ? 8 : "auto",
                        left: active ? "auto" : 4
                    }}>
                        <Icon icon="spinner-third" spin type="solid" size={12} />
                    </span>
                }
            </label>
        </div>
    )
}